module.exports = __webpack_public_path__ + "ca933e5e6ba5c7af65902046b3e75959.svg";